import React from "react";
import { Link, TitleProps } from "@refinedev/core";
import { Box, Center, Text, Title as MantineTitle } from "@mantine/core";

export const Title: React.FC<TitleProps> = ({ collapsed }) => {
  return (
    <Link to="/">
      <Center
        p="sm"
        sx={(theme) => ({
          justifyContent: collapsed ? "center" : "flex-start",
        })}
      >
        {collapsed ? (
          <Box
            sx={(theme) => ({
              width: 40,
              height: 40,
              borderRadius: 14,
              display: "grid",
              placeItems: "center",
              fontWeight: 800,
              color: theme.white,
              background:
                "linear-gradient(135deg, rgba(99, 102, 241, 1) 0%, rgba(168, 85, 247, 1) 100%)",
              boxShadow: "0 12px 24px rgba(31, 41, 55, 0.18)",
            })}
          >
            E
          </Box>
        ) : (
          <Box>
            <MantineTitle order={3} sx={{ lineHeight: 1.1, color: "white" }}>
              Ebixi Admin
            </MantineTitle>
            <Text size="xs" color="rgba(255,255,255,0.65)" sx={{ letterSpacing: "0.08em", textTransform: "uppercase" }}>
              Operations Console
            </Text>
          </Box>
        )}
      </Center>
    </Link>
  );
};
